import { useEffect, useState } from "react";
import { oauth } from "../../../utils";

const payloadMap = {
  get_tax_codes: "TaxCode",
  get_items: "Item",
  get_accounts: "Account",
  get_custom_fields: "CustomField",
  get_currencies: "CompanyCurrency",
  get_classes: "Class",
};

const preparePayload = (action) => ({
  action: "get_entity",
  entity_name: payloadMap[action],
});

export default function useQuickbookGetMappingOptions() {
  const [qboCurrencies, setQboCurrencies] = useState([]);
  const [qboItems, setQboItems] = useState([]);
  const [qboItemsLoading, setQboItemsLoading] = useState(true);
  const [qboTaxCodes, setQboTaxCodes] = useState([]);
  const [qboAccounts, setQboAccounts] = useState([]);
  const [qboCustomFields, setQboCustomFields] = useState([]);
  const [qboInvoiceFields, setQboInvoiceFields] = useState([]);
  const [qboClasses, setQboClasses] = useState([]);

  useEffect(() => {
    const call = async () => {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_tax_codes"),
      );
      const items = [];
      for (const key in res.json.taxes) {
        items.push({ name: res.json.taxes[key], ref: key });
      }
      setQboTaxCodes(items);
    };
    call();
  }, []);

  // Retry handler for fetching QBO items
  const fetchQboItems = async () => {
    setQboItemsLoading(true);
    try {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_items"),
      );
      const items = [];
      for (const key in res.json.items) {
        items.push({ name: res.json.items[key], ref: key });
      }
      setQboItems(items);
    } catch (error) {
      console.error("Failed to fetch QBO items:", error);
    } finally {
      setQboItemsLoading(false);
    }
  };

  useEffect(() => {
    fetchQboItems();
  // Disabling eslint because fetchQboItems is recreated on each render
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const call = async () => {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_accounts"),
      );
      const items = [];
      for (const key in res.json.accounts) {
        items.push({ ...res.json.accounts[key], ref: key });
      }
      setQboAccounts(items);
    };
    call();
  }, []);

  useEffect(() => {
    const call = async () => {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_custom_fields"),
      );
      const items = [];
      for (const key in res.json.custom_fields) {
        items.push(res.json.custom_fields[key]);
      }
      setQboCustomFields(items);
    };
    call();
  }, []);

  useEffect(() => {
    const call = async () => {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_currencies"),
      );
      const items = [];
      for (const key in res.json.currencies) {
        items.push(res.json.currencies[key]);
      }
      setQboCurrencies(items);
    };
    call();
  }, []);

  useEffect(() => {
    const call = async () => {
      const res = await oauth("POST", "quickbooks", {
        action: "get_invoice_fields",
      });
      const items = [];
      for (const key in res.json.invoice_fields) {
        items.push(res.json.invoice_fields[key]);
      }
      setQboInvoiceFields(items);
    };
    call();
  }, []);

  useEffect(() => {
    const call = async () => {
      const res = await oauth(
        "POST",
        "quickbooks",
        preparePayload("get_classes"),
      );
      const items = [];
      for (const key in res.json.classes) {
        items.push(res.json.classes[key]);
      }
      setQboClasses(items);
    };
    call();
  }, []);

  return [
    qboCurrencies,
    qboItems,
    qboTaxCodes,
    qboAccounts,
    qboCustomFields,
    qboInvoiceFields,
    qboClasses,
    qboItemsLoading,
    fetchQboItems,
  ];
}
